import {registerGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('nowIndicatorConfig', nowIndicatorConfig)


/* @ngInject */
function nowIndicatorConfig(AppearanceService, locale) {

    return {
        xAxis: {
            plotBands: [
                {
                    color: AppearanceService.isDarkModeActive() ? '#504F4B' : 'rgb(var(--background-dark))',
                    from: null,
                    to: null,
                    label: {
                        text: `<div class="now-indicator-label">${locale.getString('graph.now', {i18nFallback: 'Now'})}</div>`,
                        useHTML: true,
                    }
                }
            ]
        }
    }

}
